/**
 * ThemeToggle.jsx — Icon button that switches between light and dark mode.
 *
 * Reads the current theme from ThemeContext and calls toggleTheme() on click.
 * Displays a Moon icon in light mode (clicking will switch to dark) and a Sun
 * icon in dark mode (clicking will switch to light).
 *
 * Exports: ThemeToggle
 */
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { Button } from './ui/button';

/**
 * ThemeToggle — A square icon button that toggles the global theme.
 * Intended for use in the Navbar.
 */
export function ThemeToggle() {
  // Retrieve the active theme and the toggle function from ThemeContext.
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleTheme}
      className="w-10 h-10 p-0"
    >
      {/* Show Moon when light (next action = go dark), Sun when dark (next action = go light). */}
      {theme === 'light' ? (
        <Moon className="h-4 w-4" />
      ) : (
        <Sun className="h-4 w-4" />
      )}
    </Button>
  );
}
